import { createContext, useContext } from 'react';

import { TrackingUrl } from '@anyx/feature-crm/shared';

export type TrackingLinkComposerContextType = {
  insertTrackingLink?: (url: string, shorten?: boolean) => Promise<TrackingUrl | undefined>;
};

export const TrackingLinkComposerContext: React.Context<
  TrackingLinkComposerContextType | null | undefined
> = createContext<TrackingLinkComposerContextType | null | undefined>(null);

export function useTrackingLinkComposer(): TrackingLinkComposerContextType {
  const composerContext = useContext(TrackingLinkComposerContext);

  if (composerContext == null) {
    throw new Error(
      'TrackingLinkComposerContext is not provided. Make sure the component is wrapped in TrackingLinkComposerContext.Provider'
    );
  }

  return composerContext;
}
